<template>
    <!-- 결제정보 자동 등록 팝업 -->
    <div v-show='show' class='layer-pop square-type'>
        <div class='view-content' style='width: 640px;'>
            <button class='close' @click='onClosePop'><span class='blind'>팝업 닫기</span></button>
            <div class="px-6 pb-6">
              <p class='sub-title mb-4'>결제 히스토리</p>
              <ul class="info_list">
                <li>
                  <span>회원명 : </span>
                  <span class="text-primary">{{ historyInfo.nt_member_nm || '---' }}</span>
                </li>
                <li>
                  <span>주문번호 : </span>
                  <span class="text-primary">{{ historyInfo.nt_moid || '' }}</span>
                </li>
              </ul>
              <ul class="info_list">
                <li>
                  <span>결제수단 : </span>
                  <span class="text-primary">{{ historyInfo.nt_fn_cd ? cardTypes[historyInfo.nt_fn_cd] : '' }} {{ (historyInfo.nt_payment_no || '') | cardNumberFilter}}</span>
                </li>
                <li>
                  <span>할부 : </span>
                  <span v-if="!!historyInfo.nt_install_mnt"  class="text-primary">
                    ({{ historyInfo.nt_install_mnt === '00' ? '일시불' : `${Number(historyInfo.nt_install_mnt)}개월` }})
                  </span>
                  <span v-else>---</span>
                </li>
                <li>
                  <span>승인번호 : </span>
                  <span class="text-primary">{{ historyInfo.nt_app_no || '' }}</span>
                </li>
              </ul>
            </div>
            
            <div class='scroll-area com-scroll-y px-6'>
              <div class='com-table-wrap mt-3'>
                <table class='com-table'>
                  <thead>
                    <tr>
                      <th>처리일</th>
                      <th>결제상태</th>
                      <th>금액</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for='(p, index) in paymentInfoList'>
                      <tr v-if="!!p.nt_cc_dt" class='pointer select-none'>
                        <td>{{ p.nt_cc_dt | dateFormatFilter }}</td>
                        <td>
                          <span class="pay-state-R">취소</span>
                        </td>
                        <td>{{(p.nt_goods_amt || 0 ) | numberFormatFilter}}원</td>
                      </tr>
                      <tr class='pointer select-none'>
                        <td>{{ p.nt_app_dt | dateFormatFilter}}</td>
                        <td>
                          <span v-if="!p.nt_tid" class="pay-state-P">결제대기</span>
                          <span v-else class="pay-state-D">결제완료</span>
                        </td>
                        <td>{{(p.nt_goods_amt || 0 ) | numberFormatFilter}}원</td>
                      </tr>
                    </template>
                    <tr v-if='paymentInfoList.length === 0'>
                        <td colspan='100'>
                          <loading-spinner v-if='loading' :height='120'></loading-spinner>
                          <span v-else>결제정보가 없습니다.</span>
                        </td>
                    </tr>
                  </tbody>
                </table>

                <b-pagination
                    v-model='pagingInfo.page'
                    :per-page='pagingInfo.limit'
                    :total-rows='pagingInfo.totalItems'
                    align='center'
                    aria-controls='my-table'
                    first-class='first'
                    last-class='last'
                    next-class='next'
                    prev-class='prev'
                    @change='handlerPagenation($event)'
                />
              </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import LoadingSpinner from '@/components/LoadingSpinner';
import { NICEPAY_CARDS } from '@/assets/js/common';

export default {
  name: 'PaymentHistoryDlg',
  components: { LoadingSpinner },
  props: {
    show: Boolean,
    close: Function,
    moid: String, // 주문아이디
  },
  mounted() {
    this.searchKeyword = ''
    this.pagingInfo.page = 1
    this.fetchPaymentInfoList()
  },
  computed: {
    cId() {
      const {getters} = this.$store;
      return getters['auth/cId'];
    },
  },
  data() {
    return {
      loading: false,
      paymentInfoList: [],
      selectedId: null,
      searchKeyword: '',
      pagingInfo: {
        page: 1, // 페이지
        limit: 5, // 한 목록에 표출되는 건수
        totalItems: '', // 총 Item 수
        itemCount: '', // 현재 페이지 item 수
        totalPages: '', // 총 페이지 수
        route: '', // 링크 경로 생성시 프리픽스
      },
      cardTypes: NICEPAY_CARDS,
      historyInfo: {}
    };
  },
  methods: {
    async fetchPaymentInfoList() {
      if(this.loading) return
      
      this.loading = true

      try {
        const { data } = await api.get(`/admin/api/center/fitpay/transactions/${this.cId}`, {
          params: {
            moid: this.moid,
            ...this.pagingInfo
          }
        });

        this.setPageParams(data);
        this.setHistoryInfo(data);
        this.paymentInfoList = data.items;
        this.loading = false;
        
      } catch (error) {
        this.loading = false
        alert('이용권 목록을 불러오는 중 오류가 발생했습니다.');
      }
    },

    setPageParams(data) {
      this.pagingInfo.totalPages = data.meta.totalPages;
      this.pagingInfo.page = data.meta.currentPage;
      this.pagingInfo.totalItems = data.meta.totalItems;
      this.pagingInfo.itemCount = data.meta.itemCount;
    },

    setHistoryInfo(data) {
      if(!data.items || !data.items.length) {
        this.historyInfo = {};
        return
      }

      const item = data.items[0];
      this.historyInfo = {...item}
    },

    init(){

    },

    onClosePop() {
      this.close();
    },

    handleSearch(){
      
    },

    onSelectPaymentInfo(e){
      this.selectedId = e.target.value || ''
    },

    handleSubmit() {
      this.onClosePop()
    }
  },
};
</script>
<style scoped>
  .info_list{
    display: flex;
    align-items: center;
    column-gap: 16px;
    font-size: 14px;
    margin-bottom: 4px;

    li {
      position: relative;
      
      &::after {
        content: ' ';
        width: 0;
        height: 10px;
        position: absolute;
        right: -8px;
        top: 4px;
        border-right: 1px solid #BCBCBC;
      }

      &:last-child::after{
        content: none;
      }
      
    }
  }
</style>
